export const workplanSettingIndex = (theme) => {
    return {
        content: {
            flexGrow: 1,
            position: 'relative',
            zIndex: 1,
        },
        topButtonsContainer: {
            display: 'flex',
        },
        sideBar: {
            minWidth: 720,
        },
        modalText: {
            width: '100%',
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: 16,
            color: '#3A3A3A'
        }
    }
}

export const workplanSettingForm = (theme) => {
    return {
        NOOVERFLOW: {
            overflow: 'hidden !important'
        },
        textField: {
            padding: '13px'
        },
        numberContainer: {
            display: 'flex',
            alignItems: 'center',
            padding: '15px 0px',
        },
        formContainer: {
            padding: '15px',
        },
        label: {
            width: '160px'
        },
        HeaderForm: {
            color: '#767676',
            borderBottom: '1px solid #E6EDF5',
            margin: '-15px',
            padding: '15px',
            backgroundColor: 'white',
        },
        title: {
            fontSize: '17px',
            border: '1px solid #E6EDF5',
            width: 'fit-content',
            padding: '10px',
            borderRadius: '25px',
            display: 'inline-flex',
            fontWeight: 400,
        },
        addIcon: {
            color: '#0A54A2'
        },
        maxLength: {
            color: '#A9A9A9',
            fontSize: '10px',
            textAlign: 'left'
        },
        formControlLabel: {
            fontSize: 12,
            color: 'grey'
        },
        divCheckBox: {
            width: '100%'
        },
        divRadio: {
            width: '100%',
            paddingLeft: 6
        },
        divRadioYearType: {
            width: 100,
            paddingLeft: 6,
            paddingTop: 10
        },
        yearDatePicker: {
            width: 300
        },
        cursorPointer: {
            cursor: 'pointer'
        },
        divYearLenght: {
            display: 'flex'
        },
        divCheckBoxEnableCountByShiftSet: {
            paddingRight: 20,
            paddingTop: 25,
            width: 250
        },
        divCheckBoxCoverage: {
            width: '100%',
            display: 'flex'
        },
        divCheckBoxDataVisibility: {
            width: '50%',
        },
        divLabelShiftTemplateNames: {
            display: 'inline-block',
            padding: '5px 0'
        },
        headerCentered: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        },
        elementCentered: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        inputCheckBox: {
            color: "#6EA0D7",
            paddingLeft: 18
        },
        fieldWidth: {
            width: '100%',
            maxWidth: 600
        },
        shiftTemplateHeader: {
            width: 'calc(100% - 17px)',
            display: 'flex'
        },
        shiftTemplateVirtualList: {
            width: '100%'
        },
        shiftTemplateBorder: {
            border: '1px solid #e6edf5'
        },
        pushCoverageRadioButtonLabelSpacing: {
            padding: '5px 0'
        },
        pushCoverageRadioButtonLabel: {
            padding: '13px 0'
        },
        pushCoverageRadioButtonColumnLabel: {
            padding: '0 10px'
        },
        autoSwitch: {
            marginLeft: -6
        },
        coverageUpdatesLabel: {
            color: '#878787',
            marginBottom: '20px'
        },
        allowShiftSetUpdateInfo: {
            color: '#878787',
            fontSize: '12px'
        },
    }
};

export const workplanSettingTableRow = (theme) => {
    return {
        green: {
            color: 'green',
        },
        red: {
            color: 'red',
        },
        darkorange: {
            color: 'darkorange',
        },
        name: {
            width: '17.5%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: '#3A3A3A',
        },
        description: {
            width: '30%',
            color: '#3A3A3A',
        },
        type: {
            width: '10%',
            color: '#3A3A3A',
        },
        hyperFindQuery: {
            width: '17.5%',
            clear: 'both',
            display: 'inline-block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            color: '#3A3A3A',
        },
        fontAwesomeIcon: {
            margin: '7px'
        },
        buttonsAction: {
            textTransform: 'initial',
            color: '#767676',
            padding: '0px'
        },
        namefontWeigth: {
            fontWeight: 600
        },
        quotaItemStyling: {
            height: '50px',
            margin: 0,
            width: '100%',
            '&:hover': {
                backgroundColor: '#f7f9fc'
            }
        },
        buttonSection: {
            position: 'absolute',
            right: '0',
            backgroundColor: '#f7f9fc',
            borderLeft: '1px solid lightgray',
            flex: '1 20 100%',
            paddingLeft: '5px',
            paddingRight: '5px',
        },
        adjustment: {
            top: '10px'
        }
    }
}